import { render, staticRenderFns } from "./WFieldFile.vue?vue&type=template&id=136dca50&"
import script from "./WFieldFile.vue?vue&type=script&lang=ts&"
export * from "./WFieldFile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports